import { render, staticRenderFns } from "./robotForm.vue?vue&type=template&id=ed698726"
import script from "./robotForm.vue?vue&type=script&lang=js"
export * from "./robotForm.vue?vue&type=script&lang=js"
import style0 from "./robotForm.vue?vue&type=style&index=0&id=ed698726&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports